import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    autosubmit: { type: Boolean, default: false },
    requiresFlag: { type: String, default: '' }
  }

  connect() {
    if (!this.autosubmitValue) return
    if (this.requiresFlagValue && sessionStorage.getItem(this.requiresFlagValue) !== '1') return
    if (this.requiresFlagValue) sessionStorage.removeItem(this.requiresFlagValue)
    this.element.requestSubmit()
  }

  submit() {
    this.element.requestSubmit()
  }
}
